import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { contact } from '../../data/site';
type CtaBandProps = {
  title: React.ReactNode;
  text: string;
  to: string;
  label: string;
};
export function CtaBand({
  title,
  text,
  to,
  label
}: CtaBandProps) {
  return <section className="w-full bg-amber text-ink" data-id="element-234" data-mp="102n3k3i8yddo">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 py-20 md:px-10 lg:grid-cols-12 lg:items-end lg:py-24" data-id="element-235" data-mp="1000zidukeg07">
        <div className="lg:col-span-7" data-id="element-236" data-mp="r1fca5e5ect3">
          <h2 className="font-serif text-5xl leading-[0.98] tracking-tight md:text-7xl" data-id="element-237" data-mp="qzm0kbooh2e8">{title}</h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-ink/75" data-id="element-238" data-mp="m2m66y16xo2y">{text}</p>
        </div>
        <div className="flex flex-col gap-5 lg:col-span-4 lg:col-start-9" data-id="element-239" data-mp="h4kbtgybe2c6">
          <ButtonLink to={to} variant="ink" arrow className="self-start px-8 py-4" data-id="element-240" data-mp="2ggddvrzylxvr">
            {label}
          </ButtonLink>
          <div className="space-y-2 text-[15px]" data-id="element-241" data-mp="2bhjwhohjxmqb">
            <a href={contact.phoneHref} className="flex items-center gap-3 hover:underline" data-id="element-242" data-mp="2p6bomghyafmu">
              <PhoneIcon aria-hidden className="h-4 w-4" data-id="element-243" data-mp="2t7f617fncjq6" />
              {contact.phone}
            </a>
            <a href={`mailto:${contact.email}`} className="flex items-center gap-3 hover:underline" data-id="element-244" data-mp="2f85pg6nj3nlo">
              <MailIcon aria-hidden className="h-4 w-4" data-id="element-245" data-mp="2k6gywg9wvw3d" />
              {contact.email}
            </a>
          </div>
        </div>
      </div>
    </section>;
}